import moment from "moment";
import { Task } from "../../Constants/objectTypes";
import {
  ADD_NEW_SCHEDULED,
  FINISH_SCHEDULED,
  DRAG_AND_DROP,
  UNDO_DELETE_SCHEDULED,
  DELETE_SCHEDULED,
  LOAD_NEW_SCHEDULED,
} from "../../Constants/reducerEvents";
import { setScheduled } from "../../Endpoints";

const INITIAL_STATE = { completed: [], eventually: [] };
export default function schedulerReducer(state = INITIAL_STATE, action) {
  let finalState = state;
  switch (action.type) {
    case LOAD_NEW_SCHEDULED:
      return action.payload;
    case ADD_NEW_SCHEDULED:
      finalState = {
        ...state,
        [action.payload.key]: [
          ...(state[action.payload.key] ? state[action.payload.key] : []),
          action.payload.item,
        ],
      };
      setScheduled(finalState);
      return finalState;
    case FINISH_SCHEDULED:
      const newArr = [...state[action.payload.key]];
      newArr.splice(action.payload.index, 1);
      const stateWithRemoved = {
        ...state,
        [action.payload.key]: newArr,
        completed: [
          ...state.completed,
          {
            ...state[action.payload.key][action.payload.index],
            completeTime: new Date().toISOString(),
            previousKey: action.payload.key,
          },
        ],
      };

      if (newArr.length == 0) {
        delete stateWithRemoved[action.payload.key];
      }
      setScheduled(stateWithRemoved);
      return stateWithRemoved;

    case DRAG_AND_DROP: //{source:{id,index},destination:{id,index} }
      const objectMoving =
        state[action.payload.source.id][action.payload.source.index];
      const newSourceArray = state[action.payload.source.id];
      newSourceArray.splice(action.payload.source.index, 1);
      const newState = { ...state, [action.payload.source.id]: newSourceArray };
      if (
        newSourceArray.length == 0 &&
        action.payload.source.id !== "eventually"
      ) {
        delete newState[action.payload.source.id];
      }
      const newEndArray = !newState[action.payload.destination.id]
        ? []
        : newState[action.payload.destination.id];
      // console.log("newEnd", newEndArray);
      newEndArray.splice(action.payload.destination.index, 0, objectMoving);
      finalState = {
        ...newState,
        [action.payload.destination.id]: newEndArray,
      };
      setScheduled(finalState);
      return finalState;
    case UNDO_DELETE_SCHEDULED:
      finalState = {
        ...state,
        completed: state.completed.filter((t) => t.id !== action.payload.id),
        [action.payload.previousKey]: [
          ...(state[action.payload.previousKey]
            ? state[action.payload.previousKey]
            : []),
          {
            name: action.payload.name,
            id: action.payload.id,
            taskId: action.payload.taskId,
          },
        ],
      };
      setScheduled(finalState);
      return finalState;
    case DELETE_SCHEDULED:
      // console.log("delete");
      finalState = {
        ...state,
        completed: state.completed.filter((t) => t.id !== action.payload.id),
      };
      setScheduled(finalState);
      return finalState;
    default:
      return state;
  }
}
